import React, {useState} from "react";
import img1 from "./assets/img1.png";
import img2 from "./assets/img2.png";
import img3 from "./assets/img3.png";
import img4 from "./assets/img4.png";
import img5 from "./assets/img5.png";

const imageUrls = [img1, img2, img3, img4, img5];
const Benefits = () => {
  const data = [
    "Exclusive access to participate in DAO governance",
    "Access to presales for future DAO-funded projects",
    "Potential appreciation in value over time",
    "Ability to trade or sell on secondary markets",
    "A unique and collectible asset in the form of a digital NFT",
  ];
  return (
    <div className="mt-[80px] lg:mt-[154px]">
      <div className="container">
        <div className="max-w-[764px] mx-auto text-center">
          <h2 className="text-res-lg font-black text-center">Benefits</h2>
          <p className="mt-[11px] mb-[52px] text-res-xs font-semibold leading-[30px]">
            Unlock exclusive benefits and opportunities with R34P DAO NFTs.
          </p>

          <div className="flex gap-x-[37px] flex-wrap justify-center gap-y-[54px]">
            {data.map((single, i) => (
              <div className="w-[230px]" key={i}>
                <div className="flex justify-center mb-[13px]">
                  <img
                    className="w-[172px] h-[94px]"
                    src={imageUrls[i]}
                    alt=""
                  />
                </div>
                <p className="text-res-xs leading-[30px] font-semibold">
                  {single}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
